import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="mb-6">
        <h2 className="font-display text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-3">
          <span className="w-1.5 h-6 rounded-full bg-primary-500"></span>
          分类快捷入口
        </h2>
        <p className="mt-2 text-xs md:text-sm text-foreground-500 pl-4">
          按内容类型快速进入，找到你想看的视频
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {categories.map((c) => (
          <Link
            key={c.key}
            to={`/category/${c.key}`}
            className="group relative rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer h-40 md:h-52"
          >
            <img
              src={c.cover}
              alt={`${c.name}分类`}
              title={`${c.name} - 在线视频分类`}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/90 via-secondary-950/45 to-secondary-950/10"></div>
            <div className="relative z-10 h-full flex flex-col justify-end p-4 md:p-5">
              <span className="w-10 h-10 rounded-lg bg-primary-500/95 flex items-center justify-center mb-2">
                <i className={`${c.icon} text-background-50 text-xl`}></i>
              </span>
              <h3 className="font-display text-lg md:text-xl font-bold text-background-50">{c.name}</h3>
              <p className="mt-1 text-xs text-background-200 line-clamp-2 hidden sm:block">{c.desc}</p>
              <span className="mt-2 text-xs text-accent-300 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                进入分类 <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}